import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Link } from '../ui/link';
export function SkipNav() {
  const $ = _c(5);
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      hash: "main-content"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("layout.skip-to-main-content");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Link href={t0} className="fixed left-4 z-50 -translate-y-20 rounded-4xl border bg-background px-3 py-2 font-medium transition-transform focus:outline-none focus-visible:translate-y-0 focus-visible:ring-3 focus-visible:ring-ring focus-visible:ring-offset-2">{t1}</Link>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}